"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttributeType;
(function (AttributeType) {
    AttributeType["ROI"] = "roi";
    AttributeType["CHANNEL"] = "channel";
    AttributeType["BRAND"] = "brand";
    AttributeType["DURATION"] = "duration";
    AttributeType["SEGMENT_TYPE"] = "segment_type";
    AttributeType["HAS_PRODUCT"] = "has_product";
    AttributeType["HAS_PRODUCT_TYPE"] = "has_product_type";
    AttributeType["CUSTOMER_STATUS"] = "customer_status";
    AttributeType["CUSTOMER_PHASE"] = "customer_phase";
    AttributeType["PARTNER_SEGMENT"] = "partner_segment";
    AttributeType["TIME_START_CONTRACT"] = "time_start_contract";
    AttributeType["TIME_END_CONTRACT"] = "time_end_contract";
    AttributeType["ACQUISITION_SCORE"] = "acquisition_score";
    AttributeType["LOYALTY"] = "loyalty";
    AttributeType["HAS_SOLAR_PANELS"] = "has_solar_panels";
})(AttributeType || (AttributeType = {}));
exports.default = AttributeType;
